<div class="card">
    <div class="card-body">
        <div class="heading flex items-center gap-4 w-full justify-between">
            <h6 class="text-lg text-gray-500 font-semibold mb-6">ITagTip Users</h6>
            <div class="flex-1 min-w-0">
                <div class="relative flex items-center">
                    <input type="text" [(ngModel)]="searchQuery" (keyup.enter)="onSearch(searchQuery)"
                        (input)="onSearchInputChanged()" placeholder="Search users..."
                        class="w-full py-2 px-4 border rounded-xl focus:outline-none focus:ring-2 focus:ring-gray-500" />
                    <button class="bg-gray-500 text-white px-4 search-button rounded-xl hover:bg-gray-600"
                        (click)="onSearch(searchQuery)">
                        <i class="uil uil-search"></i>
                    </button>
                </div>
            </div>

        </div>

        <app-preloader *ngIf="loading"></app-preloader>
        <div class="relative overflow-x-auto" *ngIf="!loading">
            <table class="text-left w-full whitespace-nowrap text-sm text-gray-500">
                <thead>
                    <tr class="text-sm">
                        <th scope="col" class="p-4 font-semibold">User name</th>
                        <th scope="col" class="p-4 font-semibold">Device Count</th>
                        <th scope="col" class="p-4 font-semibold">Last Updated</th>
                        <th scope="col" class="p-4 font-semibold">Availability</th>
                        <th scope="col" class="p-4 font-semibold">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let user of users| paginate
                    : {
                        itemsPerPage: pageSize,
                        currentPage: currentPage,
                        totalItems: totalItems
                      };
                  let i = index">
                        <td class="p-4 text-sm">
                            <div class="flex gap-6 items-center">
                                <div class="h-12 w-12 inline-block">
                                    <img [src]="user.profileImageUrl" alt="" class="rounded-full w-100">
                                </div>
                                <div class="flex flex-col gap-1 text-gray-500">
                                    <h3 class=" font-bold">{{ user.name || "N/A"}}</h3>
                                </div>
                            </div>
                        </td>
                        <td class="p-4">
                            <h3 class="font-medium">{{user.devices?.length ? user.devices?.length + ' Device(s)' :
                                'N/A'}}</h3>
                        </td>
                        <td class="p-4">
                            {{(user.devices && user.devices.length) ? (user.devices[0].updatedAt | date:'medium') :
                            'N/A'}}
                        </td>
                        <td class="p-4">
                            <span
                                class="inline-flex items-center py-2 px-4 rounded-3xl font-semibold bg-gray-200 text-gray-400">Offline</span>
                            <!-- bg-gray-200 border rounded-sm p-4 border-gray-100 text-sm text-gray-400  -->
                            <!-- <span class="inline-flex items-center py-2 px-4 rounded-3xl font-semibold bg-teal-400 text-teal-500">Online</span> -->
                        </td>
                        <td class="p-4">
                            <div class="kebab-wrapper" (click)="$event.stopPropagation()">
                                <button class="kebab-trigger" (click)="toggleMenu(user._id)" title="Actions">
                                    <i class="ti ti-dots-vertical"></i>
                                </button>

                                <div class="kebab-dropdown" *ngIf="openMenuId === user._id">
                                    <!-- View -->
                                    <a class="kebab-item" routerLink="/portal/user/{{user._id}}/locations"
                                        (click)="closeMenu()">
                                        <i class="ti ti-eye kebab-icon icon-view"></i>
                                        <span>View Profile</span>
                                    </a>

                                    <!-- Disable (active user) -->
                                    <button *ngIf="user.status !== 'Suspended'" class="kebab-item"
                                        (click)="triggerDisable(user); closeMenu()">
                                        <i class="ti ti-ban kebab-icon icon-disable"></i>
                                        <span>Disable User</span>
                                    </button>

                                    <!-- Enable (suspended user) -->
                                    <button *ngIf="user.status === 'Suspended'" class="kebab-item"
                                        (click)="triggerEnable(user); closeMenu()">
                                        <i class="ti ti-circle-check kebab-icon icon-enable"></i>
                                        <span>Enable User</span>
                                    </button>

                                    <div class="kebab-divider"></div>

                                    <!-- Delete -->
                                    <button class="kebab-item kebab-item--danger"
                                        (click)="triggerDelete(user); closeMenu()">
                                        <i class="ti ti-trash kebab-icon"></i>
                                        <span>Delete User</span>
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>

                </tbody>
            </table>
        </div>
    </div>
</div>

<div class="card" *ngIf="totalItems > pageSize">
    <div class="card-body flex justify-center" style="margin-top: 20px;">
        <nav class="flex justify-center items-center">
            <pagination-controls (pageChange)="renderPage($event)"></pagination-controls>
        </nav>
    </div>
</div>